import React from 'react';
import Icon from 'components/AppIcon';
import Input from 'components/ui/Input';

const GameOutcomeSelector = ({ outcome, onOutcomeChange, gameDate, onDateChange, location, onLocationChange, errors, hideOutcome }) => {
  return (
    <div className="bg-[var(--color-card)] rounded-xl border border-[var(--color-border)] p-4 md:p-6">
      <h3 className="font-heading font-semibold text-base md:text-lg mb-4" style={{ color: 'var(--color-foreground)' }}>
        Game Details
      </h3>
      <div className={`grid gap-4 ${hideOutcome ? 'grid-cols-1 md:grid-cols-2' : 'grid-cols-1 md:grid-cols-3'}`}>
        {!hideOutcome && (
          <div>
            <p className="font-caption text-sm font-medium mb-2" style={{ color: 'var(--color-foreground)' }}>
              Game Outcome <span className="text-red-500">*</span>
            </p>
            <div className="flex gap-3">
              {['Win', 'Loss']?.map((opt) => (
                <button
                  key={opt}
                  onClick={() => onOutcomeChange(opt)}
                  className={`flex-1 flex items-center justify-center gap-2 py-2.5 px-4 rounded-lg border-2 font-caption font-semibold text-sm transition-all min-h-[44px] ${
                    outcome === opt
                      ? opt === 'Win' ?'border-emerald-500 bg-emerald-50 text-emerald-700 dark:bg-emerald-950/20' :'border-red-500 bg-red-50 text-red-700 dark:bg-red-950/20' :'border-[var(--color-border)] bg-[var(--color-muted)] text-[var(--color-muted-foreground)] hover:border-gray-400'
                  }`}
                  aria-pressed={outcome === opt}
                >
                  <Icon
                    name={opt === 'Win' ? 'Trophy' : 'X'}
                    size={16}
                    color={outcome === opt ? (opt === 'Win' ? '#059669' : '#DC2626') : 'currentColor'}
                  />
                  {opt}
                </button>
              ))}
            </div>
            {errors?.outcome && <p className="text-xs text-red-500 mt-1">{errors?.outcome}</p>}
          </div>
        )}
        <div>
          <Input
            label="Game Date"
            type="date"
            value={gameDate}
            onChange={(e) => onDateChange(e?.target?.value)}
            required
            error={errors?.gameDate}
          />
        </div>
        <div>
          <Input
            label="Location (Optional)"
            type="text"
            placeholder="e.g. Riverside Court"
            value={location}
            onChange={(e) => onLocationChange(e?.target?.value)}
          />
        </div>
      </div>
    </div>
  );
};

export default GameOutcomeSelector;